<template>
    <div>
        <template v-if="type === MeetingLocationTypeEnum.Phone">
            <svg
                xmlns="http://www.w3.org/2000/svg"
                x="0px"
                y="0px"
                :width="iconSize"
                :height="iconSize"
                viewBox="0 0 50 50"
            >
                <path
                    d="M 14 3.9902344 C 8.4886661 3.9902344 4 8.4789008 4 13.990234 L 4 35.990234 C 4 41.501568 8.4886661 45.990234 14 45.990234 L 36 45.990234 C 41.511334 45.990234 46 41.501568 46 35.990234 L 46 13.990234 C 46 8.4789008 41.511334 3.9902344 36 3.9902344 L 14 3.9902344 z M 18.005859 12.033203 C 18.633859 12.060203 19.210594 12.414031 19.558594 12.957031 C 19.954594 13.575031 20.569141 14.534156 21.369141 15.785156 C 22.099141 16.926156 22.150047 18.399844 21.498047 19.589844 L 20.033203 21.673828 C 19.637203 22.237828 19.558219 22.959703 19.824219 23.595703 C 20.238219 24.585703 21.040797 26.107203 22.466797 27.533203 C 23.892797 28.959203 25.414297 29.761781 26.404297 30.175781 C 27.040297 30.441781 27.762172 30.362797 28.326172 29.966797 L 30.410156 28.501953 C 31.600156 27.849953 33.073844 27.901859 34.214844 28.630859 C 35.465844 29.430859 36.424969 30.045406 37.042969 30.441406 C 37.585969 30.789406 37.939797 31.366141 37.966797 31.994141 C 38.120797 35.558141 35.359641 37.001953 34.556641 37.001953 C 34.000641 37.001953 27.316344 37.761656 19.777344 30.222656 C 12.238344 22.683656 12.998047 15.999359 12.998047 15.443359 C 12.998047 14.640359 14.441859 11.879203 18.005859 12.033203 z"
                ></path>
            </svg>
        </template>
        <template v-if="type === MeetingLocationTypeEnum.Zoom">
            <svg
                xmlns="http://www.w3.org/2000/svg"
                x="0px"
                y="0px"
                :width="iconSize"
                :height="iconSize"
                viewBox="0 0 48 48"
            >
                <circle
                    cx="24"
                    cy="24"
                    r="20"
                    fill="#2196f3"
                ></circle>
                <path
                    fill="#fff"
                    d="M29,31H14c-1.657,0-3-1.343-3-3V17h15c1.657,0,3,1.343,3,3V31z"
                ></path>
                <polygon
                    fill="#fff"
                    points="37,31 31,27 31,21 37,17"
                ></polygon>
            </svg>
        </template>
        <template v-if="type === MeetingLocationTypeEnum.GoogleMeet">
            <svg
                xmlns="http://www.w3.org/2000/svg"
                x="0px"
                y="0px"
                :width="iconSize"
                :height="iconSize"
                viewBox="0 0 48 48"
            >
                <rect
                    width="16"
                    height="16"
                    x="12"
                    y="16"
                    fill="#fff"
                    transform="rotate(-90 20 24)"
                ></rect>
                <polygon
                    fill="#1e88e5"
                    points="3,17 3,31 8,32 13,31 13,17 8,16"
                ></polygon>
                <path
                    fill="#4caf50"
                    d="M37,24v14c0,1.657-1.343,3-3,3H13l-1-5l1-5h14v-7l5-1L37,24z"
                ></path>
                <path
                    fill="#fbc02d"
                    d="M37,10v14H27v-7H13l-1-5l1-5h21C35.657,7,37,8.343,37,10z"
                ></path>
                <path
                    fill="#1565c0"
                    d="M13,31v10H6c-1.657,0-3-1.343-3-3v-7H13z"
                ></path>
                <polygon
                    fill="#e53935"
                    points="13,7 13,17 3,17"
                ></polygon>
                <polygon
                    fill="#2e7d32"
                    points="38,24 37,32.45 27,24 37,15.55"
                ></polygon>
                <path
                    fill="#4caf50"
                    d="M46,10.11v27.78c0,0.84-0.98,1.31-1.63,0.78L37,32.45v-16.9l7.37-6.22C45.02,8.8,46,9.27,46,10.11z"
                ></path>
            </svg>
        </template>
        <template
            v-if="
                [
                    MeetingLocationTypeEnum.InPersonHostDefined,
                    MeetingLocationTypeEnum.InPersonAttendeeDefined,
                ].includes(type)
            "
        >
            <svg
                xmlns="http://www.w3.org/2000/svg"
                x="0px"
                y="0px"
                :width="iconSize"
                :height="iconSize"
                viewBox="0 0 640 640"
            >
                <!--!Font Awesome Free v7.1.0 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free Copyright 2025 Fonticons, Inc -->
                <path
                    d="M128 252.6C128 148.4 214 64 320 64C426 64 512 148.4 512 252.6C512 371.9 391.8 514.9 341.6 569.4C329.8 582.2 310.1 582.2 298.3 569.4C248.1 514.9 127.9 371.9 127.9 252.6zM320 320C355.3 320 384 291.3 384 256C384 220.7 355.3 192 320 192C284.7 192 256 220.7 256 256C256 291.3 284.7 320 320 320z"
                />
            </svg>
        </template>
    </div>
</template>

<script setup lang="ts">
    import type { PropType } from 'vue'
    import { MeetingLocationTypeEnum } from '@/Shared/AutoGenerated/Main'

    const props = defineProps({
        type: {
            type: String as PropType<MeetingLocationTypeEnum>,
            required: true,
        },
        iconSize: {
            type: Number,
            required: true,
        },
    })
</script>
